<template>
  <div class="spinner-container" role="status" :aria-label="T('Loading...')">
    <FhSpinner size="lg" />
  </div>
</template>

<script setup>
import { FhSpinner } from '@fareharbor-com/beacon-vue';
</script>

<style scoped>
.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.65);
}
</style>
